import { action } from '@ember/object';
import { isEmpty, isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { ContactCustomPropertyInfoSettings } from 'donor-elf-web/services/contacts-cache';
import { Changeset } from 'ember-changeset';
import { TrackedArray } from 'tracked-built-ins';

export interface CustomPropertyEditListOptionsSaveHandler {
  options: string[];
  settings?: ContactCustomPropertyInfoSettings;
}

interface ComponentArgs {
  existingOptions?: string[];
  existingSettings?: ContactCustomPropertyInfoSettings;
  onSave: (args: CustomPropertyEditListOptionsSaveHandler) => void;
}

interface Option {
  val: string;
}

export default class ContactDetailsPropertiesCustomPropertyEditListOptionsComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);

    this.changeset = Changeset({
      allowMultipleSelections: !(
        args.existingSettings?.single_selection ?? false
      ),
    });

    const options = (args.existingOptions || []).map((x) => {
      return { val: x };
    });

    if (options.length === 0) {
      options.push({ val: '' });
    }

    this.options = new TrackedArray(options);
  }

  changeset: any;
  options: TrackedArray<Option>;
  @tracked errorCantAddOption = false;
  @tracked errorNoOptions = false;

  @action
  addOption(event?: any) {
    if (
      this.options.length > 0 &&
      isEmpty(this.options[this.options.length - 1]?.val)
    ) {
      this.errorCantAddOption = true;
    } else {
      this.errorCantAddOption = false;
      this.options.push({ val: '' });
    }

    if (event) {
      // scroll the options div all the way down
      setTimeout(() => {
        let optionsDiv = event.target.closest('.overflow-auto');
        optionsDiv.scrollTop = optionsDiv.scrollHeight;
      });
    }
  }

  @action
  handleOptionEnter(option: Option, index: number, event: any) {
    option.val = event.target.value;
    if (index === this.options.length - 1 && isPresent(option.val)) {
      this.addOption(event);
    }
  }

  @action
  handleInputChange(option: Option, e: any) {
    option.val = e.target.value;
  }

  @action
  save() {
    let settings: ContactCustomPropertyInfoSettings | undefined;
    if (this.changeset.get('allowMultipleSelections') === false) {
      settings = { single_selection: true };
    }
    let options = this.options
      .filter((x) => isPresent(x.val))
      .map((x) => x.val.trim());
    if (options.length === 0) {
      this.errorNoOptions = true;
    } else {
      this.args.onSave({ options, settings });
    }
  }
}
